'use client'

import ReactDOM from 'react-dom'

export default function PreloadResources({ cdnOrigin }: { cdnOrigin: string }) {
  // Use only `prefetchDNS` for the assets CDN: Lighthouse reports the
  // `preconnect` hint as unused because the first request to this origin
  // does not happen early enough in the page load to benefit from the
  // pre-established connection. DNS prefetch is a much cheaper hint and
  // is not flagged. See: https://web.dev/uses-rel-preconnect/
  ReactDOM.prefetchDNS(cdnOrigin)

  return null
}
